/* jshint node:true */
'use strict';

var Debug = require('debug');
var clientDebug = require('debug')('app:client:debug');
var React = require('react');
var Router = require('react-router');
var HistoryLocation = require('./app/helpers/HistoryLocation');
var appConfig = require('./config');
var app = require('./app')(appConfig.uid);
var browser = require('./app/helpers/utils/browser');
var clientStateHandlers = require('./app/helpers/clientStateHandlers.js');
var Path = require('./app/helpers/utils/path.js');
var inited = false;

window.Debug = Debug;

Debug.disable();

var context = app.createContext();

function renderReact(context, Handler, sport, routeChange, state){
    var actionContext = context.getActionContext();
    var isGamePackage = isGamePackageRoute(state.routes) && !(window.__noShell === true);

    /**
     * Check and append main-container div
     * if route is game package and if the div doesn't exist
     */
    if(!jQuery('#pane-main>#' + appConfig.uid).length && isGamePackage){
        appendPlaceholder();
    }

    try{
        React.render(
            React.createElement(
                Handler, {
                    context: context.getActionContext()
                }
            ),
            document.getElementById(appConfig.uid),
            function(){
                var request = Path.decode(this.state.pathname);
                clientStateHandlers.postRouteRender(sport, request.page, routeChange, isGamePackage);
                clientDebug('Render complete');
            }
        );
    }catch(e){
        console.log(e.stack || e);
    }
}

/**
 * Appends the main-container
 */
function appendPlaceholder(){
    try {
        jQuery('#pane-main').append('<div id="' + appConfig.uid + '" ></div>');
    }catch(e){}
}

/**
 * Checks if the current route is gamepackage
 * @param  {Array}  routes
 * @return {Boolean}
 */
function isGamePackageRoute(routes){
    var isGamePackage = false;
    routes = routes || [];

    routes.map(function(r, i){
        if(r && r.handler && r.handler.displayName === 'Gamecast'){
            isGamePackage = true;
        }
    });
    return isGamePackage;
}

/**
 * Checks and returns `true` if route has changed
 * @param  {Object}  state
 * @return {Boolean}
 */
function hasRouteChanged(state){
    return (!!((history.state && history.state.path || '').replace(/\/?$/, '/') !== state.path.replace(/\/?$/, '/')))
}

Router.run(app.getComponent(), HistoryLocation, function(Handler, state) {
    if(!inited){
        inited = true;
    }
    var request = Path.decode(state.pathname);
    var sport = state.params.league;
    /**
     * Execute pre render tasks
     */
    var routeChange = hasRouteChanged(state);
    clientStateHandlers.preRouteRender(sport, request.page, routeChange);
    var actions = state.routes.filter(function(route) {
        /**
         * Actions for Proxy loaded components are in the Mixin object
         */
        route.handler.loadAction = route.handler.loadAction || route.handler.Mixin && route.handler.Mixin.loadAction;
        return route.handler.loadAction ? true : false;
    });
    /**
     * if actions exist, execute them, else render directly
     * @param  {Array} actions.length
     */
    if(actions.length){
        clientDebug('Load action found');
        actions.map(function(route, i) {
            state.appInited = inited;
            context.getActionContext().executeAction(route.handler.loadAction, state, function() {
                renderReact(context, Handler, sport, routeChange, state);
            });
        });
    }else{
        clientDebug('Load action not found');
        renderReact(context, Handler, sport, routeChange, state);
    }
});



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/client.js
 **/